import amplitude from "amplitude-js";
import { useCallback } from "react";

amplitude.getInstance().init("48979423ae2c7c8a1b72218baf99fbfc");

export const useAmplitudeEventLogger = (eventName) => {
  return useCallback(
    (eventProperties) =>
      amplitude.getInstance().logEvent(eventName, eventProperties),
    [eventName]
  );
};
